import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DynamicArticleService} from 'projects/iw-shop/src/lib/dynamic-article/services/dynamic-article.service';
import {ApiDynamicArticle} from '@api/dynamic-articles';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {distinctUntilChanged, Subject} from 'rxjs';
import {debounceTime, filter, map, takeUntil} from 'rxjs/operators';
import {HTTPQueue} from "@iw-shop/core/classes/http-queue";

@Component({
    selector: 'iw-shop-dynamic-articles',
    standalone: false,
    templateUrl: './dynamic-articles.component.html',
    styleUrls: ['./dynamic-articles.component.scss']
})
export class DynamicArticlesComponent implements OnInit, OnDestroy {
    @Input() writeable: boolean = true;
    @Input() dynamicArticleCategories:  ApiDynamicArticle['category'][] = ['deliverySelectable', 'deliveryOverlay', 'selection', 'selectionWithOptionalMappingToCustomer', 'additionalArticle'];
    @Output() onLoadingComplete = new EventEmitter();
    destroy$: Subject<boolean> = new Subject<boolean>();

    items?: ApiDynamicArticle[];

    constructor(
        private store: Store<AppState>,
        private dynamicArticleService: DynamicArticleService,
        private httpQueue: HTTPQueue) {
        this.store.select(state => state.shoppingCart)
            .pipe(
                takeUntil(this.destroy$),
                debounceTime(500),
                filter(state => state.requestsCounter == state.requestsDone),
                filter(shoppingCart => !!shoppingCart?.id && (shoppingCart.items?.articles?.length ?? 0) > 0),
                map(shoppingCart => shoppingCart.items),
                distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
            )
            .subscribe(
                r => {
                    this.httpQueue.invoke(
                        this.dynamicArticleService.getByCategory('dynamicArticles.constructor', this.dynamicArticleCategories)
                    ).pipe(
                        takeUntil(this.destroy$)
                    ).subscribe(
                        {
                            next: (r) => {
                                if (r?.result) {
                                    this.items = r.result?.dynamicArticles.data;
                                }
                                this.onLoadingComplete.emit();
                            },
                            complete: () => {
                                this.onLoadingComplete.emit();
                            }
                        }
                    );
                }
            );
    }

    ngOnInit() {
    }

    getItems(categories?: ApiDynamicArticle['category'][], excludeCategories?: ApiDynamicArticle['category'][]): ApiDynamicArticle[] | undefined {
        return this.items
            ?.filter(x => categories?.includes(x.category) || categories?.length == 0)
            .filter(x => !excludeCategories?.includes(x.category));
    }


    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
